import { useContext, useEffect, useRef } from 'react'
import PropTypes from 'prop-types'

// Context
import { CalendarContext } from '../../context/CalendarContext'

const CalendarIndicator = (props) => {
  const { scrollToIndicator = true } = props
  const indicatorRef = useRef()
  const calendarContext = useContext(CalendarContext)

  useEffect(() => {
    if (scrollToIndicator && !calendarContext.routerChanged && calendarContext.seasonActiveState) {
      setTimeout(() => {
        indicatorRef?.current?.scrollIntoView({ behavior: 'smooth', block: 'center' })
      }, 300)
    }
  }, [])

  return (
    <div
      className={`CalendarIndicator ${!calendarContext.seasonActiveState ? 'CalendarIndicator--hidden' : ''}`}
      ref={indicatorRef}
    >
      <div className="CalendarIndicator-object"></div>
    </div>
  )
}

CalendarIndicator.propTypes = {
  scrollToIndicator: PropTypes.bool
}

export default CalendarIndicator
